import type { GenerationStep, OptionItem } from "@/types/generation.types";
import type { GeneratedQuestionsResult } from "@/types/apis/naniexpert";
import { createContext } from "react";

export type GenerationContextType = {
  step: GenerationStep;
  setStep: (step: GenerationStep) => void;
  generationResult: GeneratedQuestionsResult | null;
  selectedEdu: string | null;
  selectedSubject: string | null;
  selectedVolume: string | null;
  selectedChapter: string | null;
  selectedSubChapter: string | null;
  customText: string;
  setSelectedEdu: (edu: string | null) => void;
  setSelectedSubject: (subject: string | null) => void;
  setSelectedVolume: (volume: string | null) => void;
  setSelectedChapter: (chapter: string | null) => void;
  setSelectedSubChapter: (subChapter: string | null) => void;
  setCustomText: (text: string) => void;
  eduOptions: OptionItem[];
  subjectOptions: OptionItem[];
  volumeOptions: OptionItem[];
  chapterOptions: OptionItem[];
  subChapterOptions: OptionItem[];
  handleGenerate: () => Promise<void>;
};

export const GenerationContext = createContext<GenerationContextType | null>(
  null
);
